import React, { useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";
import { Container, Row, Col } from "react-bootstrap";
import FaxIcon from '@mui/icons-material/Fax';
import ArticleIcon from '@mui/icons-material/Article';
import { MdOutlineModeEditOutline, MdSupervisedUserCircle, MdAccountCircle, MdClose } from "react-icons/md";
import CancelIcon from '@mui/icons-material/Cancel';
import Lead from "../../shared/Lead";
import EditIcon from '@mui/icons-material/Edit';
import * as API from "../../api";
import Loading from "../../shared/Loading";
import Select from "../../shared/Select";
import TextArea from "../../shared/TextArea";
import Patient from "../../shared/Patient";
import FieldError from "../../shared/FieldError";

const SpecialistReferralTask = ({ task, dispatch, isCall, formHandler }) => {
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(false);
  const [refaxed, setRefaxed] = useState(false);
  const [supportingDocs, setSupportingDocs] = useState({ doc1: null, doc2: null, doc3: null });
  const [uploadingDocs, setUploadingDocs] = useState(false);
  const [showReplaceDocs, setShowReplaceDocs] = useState(false);
  const history = useHistory();

  const handleUploadSupportingDocs = async () => {
    if (!supportingDocs.doc1 && !supportingDocs.doc2 && !supportingDocs.doc3) {
      alert('Please select at least one file to upload.');
      return;
    }
    setUploadingDocs(true);
    const formData = new FormData();
    formData.append('task[specialist_referral_attributes][id]', task.specialist_referral_id);
    if (supportingDocs.doc1) formData.append('task[specialist_referral_attributes][supporting_document]', supportingDocs.doc1);
    if (supportingDocs.doc2) formData.append('task[specialist_referral_attributes][supporting_document_2]', supportingDocs.doc2);
    if (supportingDocs.doc3) formData.append('task[specialist_referral_attributes][supporting_document_3]', supportingDocs.doc3);
    try {
      await API.updateTask(task.id, formData);
      alert('Supporting documents uploaded successfully.');
      setSupportingDocs({ doc1: null, doc2: null, doc3: null });
    } catch (e) {
      alert('There was an error uploading the documents.');
    }
    setUploadingDocs(false);
  };

  return (
    <>
      <Container>
        <Row>
          { !task.has_pending_fax && !editing && !refaxed && (
            <Col md={3}>
              <button
                  onClick={async (el) => {
                  let response = await API.faxSpecialistReferral(task.specialist_referral_id);
                  if(response) {
                    alert('A fax has been scheduled to be sent in 5 minutes.');
                    setRefaxed(true);
                  }
                }}
              >
                <FaxIcon /> Re-fax
              </button>
            </Col>
            )
          }
          { task.has_pending_fax && (
            <Col md={3}>
              <button
                onClick={async (el) => {
                  let response = await API.cancelFaxSpecialistReferral(task.specialist_referral_id);
                  if(response) {
                    alert('Fax cancelled!');
                  }
                }}
              >
                <CancelIcon /> Cancel Fax
              </button>
            </Col>
            )
          }
          <Col md={3}>
            <button
              disabled={true}
              onClick={(el) => {
                //setEditing(!editing);
              }}
            >
              { !editing && (
                <>
                  <EditIcon /> Edit Referral (Disabled)
                </>
              )}
              { editing == true && (
                <>
                  Close
                </>
              )}
            </button>
          </Col>
          <Col md={3}>
            <button
                onClick={async (el) => {
                let response = await API.regenerateSpecialistReferralPdf(task.specialist_referral_id);
                if(response) {
                  alert('A new PDF is being regenerated.');
                  setRefaxed(true);
                }
              }}
            >
              <ArticleIcon /> Re-generate PDF
            </button>
          </Col>
          <Col md={3}>
            <button
              onClick={async (el) => {
                let response = confirm('Are you sure you want to delete this referral task? This cannot be undone!');

                if(response) {
                  let response = await API.deleteSpecialistReferral(task.specialist_referral_id);
                  if (response) {
                    history.push("/physicians/tasks");
                  }
                }
              }}
            >
              { !editing && (
                <>
                  Delete Referral
                </>
              )}
            </button>
          </Col>
        </Row>
        <Row className='m-t-lg'>
          <Col md={3}>
            <button onClick={() => setShowReplaceDocs(true)}>
              Replace Supporting Documents
            </button>
          </Col>
        </Row>
        {showReplaceDocs && (
          <Row className='m-t-lg'>
            {[
              { key: 'doc1', label: 'Supporting Document 1', urlField: 'specialist_referral_supporting_document_url' },
              { key: 'doc2', label: 'Supporting Document 2', urlField: 'specialist_referral_supporting_document_2_url' },
              { key: 'doc3', label: 'Supporting Document 3', urlField: 'specialist_referral_supporting_document_3_url' },
            ].map(({ key, label, urlField }) => (
              <Col md={3} key={key}>
                <div>
                  <label><strong>{label}</strong></label>
                  {task[urlField] && (
                    <div>
                      <a href={task[urlField]} target="_blank" rel="noreferrer">
                        {decodeURIComponent(task[urlField].split('/').pop().split('?')[0])}
                      </a>
                    </div>
                  )}
                  <input
                    type="file"
                    onChange={(e) => setSupportingDocs((prev) => ({ ...prev, [key]: e.target.files[0] || null }))}
                  />
                </div>
              </Col>
            ))}
            <Col md={3} className='d-flex align-items-end'>
              <div>
                <button onClick={handleUploadSupportingDocs} disabled={uploadingDocs}>
                  {uploadingDocs ? 'Uploading...' : 'Upload Supporting Documents'}
                </button>
                <br />
                <button onClick={() => setShowReplaceDocs(false)} style={{ backgroundColor: 'red', color: 'white' }}>
                  Cancel
                </button>
              </div>
            </Col>
          </Row>
        )}
        <Row>
          <Col>
            <div className='m-t-lg'>
              {
                editing == true && (
                  <Formik
                    initialValues={{
                      reason: "",


                    }}
                    onSubmit={(values) => {
                    }}
                  >
                  {({
                    values,
                    errors,
                    touched,
                    setFieldValue
                  }) => (
                    <Form>
                      <div>
                        <h3><EditIcon /> Edit Specialist Referral</h3>
                        <label>Reason</label>
                        <input
                          style={{ width: "auto" }}
                          type="text"
                          placeholder={'Reason'}
                          onChange={(e) => setFieldValue(name, e.target.value)}
                          name={"task[" + name + "]"}
                        />
                        <br />
                      </div>
                    </Form>
                  )}

                </Formik>
              )}
            </div>
          </Col>
        </Row>
        {
          editing != true && (
            <Row>
              <Col>
                { task.specialist_referral_document_url && (<>
                    A <b>specialist referral in PDF</b> form has been auto-generated in case.
                    <br />
                    <a href={task.specialist_referral_document_url}>Click here to view PDF</a>
                    <br />
                    {task.specialist_opened_at && <>
                      <i> <i className='fa fa-eye' /> Downloaded at {task.specialist_opened_at} </i>
                    </>}
                  </>)
                }
                { task.retroactive && (<>
                    <br />
                    This specialist referral is <b>retroactive</b>.
                  </>)
                }
                { !task.specialist_referral_document_url && (<>
                    <br />
                    A specialist Referal PDF is being generated and will be available soon.
                  </>)
                }
                {
                    task.specialist_referral_supporting_document_url && (
                      <>
                        <br />
                        A support agent uploaded a <b> supporting document</b>.
                        <br />
                        <a href={task.specialist_referral_supporting_document_url}>Click here to view supporting document.</a>
                      </>
                    )
                }

                {
                    task.specialist_referral_supporting_document_2_url && (
                      <>
                        <a href={task.specialist_referral_supporting_document_2_url}>Click here to view supporting document 2.</a>
                      </>
                    )
                }

                {
                    task.specialist_referral_supporting_document_3_url && (
                      <>
                        <a href={task.specialist_referral_supporting_document_3_url}>Click here to view supporting document 3.</a>
                      </>
                    )
                }
                {
                  [true, false].includes(task.specialist_referral_faxed) && (
                    <>
                      <br />
                      Fax Status: { task.specialist_referral_faxed == true ? "Success" : (<>
                        <b>Unsuccessful</b> <br />
                        <div>
                          Fax number used: { task.specialist_referral_fax_number || 'None' } <br />
                          Error Message: { task.specialist_referral_fax_message || 'None' }
                        </div>
                      </>) }
                      <br />
                    </>
                  )
                }

                {
                  task.specialist_referral_details && (
                    <div className={'small panel specialist-referral-details-container'}>
                      <div className={'panel-body'}
                        dangerouslySetInnerHTML={{
                          __html: task.specialist_referral_details,
                        }}
                      />
                    </div>
                  )

                }
              </Col>
            </Row>
          )
        }
      </Container>
    </>
  );
};

export default SpecialistReferralTask;
